import React, { useContext } from "react";
import { Redirect, Route } from "react-router-dom";
import { UserContext } from "./Auth/UserContextProvider";

function ManagerRoute({ component: Component, ...rest }) {
  const { isAdmin, isManager } = useContext(UserContext);

  return (
    <Route
      {...rest}
      render={(props) =>
        (isManager || isAdmin) ? <Component {...props} /> : <Redirect to="/home" />
      }
    />
  );
}

export default ManagerRoute;
